import MArrowRightUpIcon from '@/assets/manifold-icons/arrow-right-up.svg';

interface ExternalLinkSectionProps {
  title: string;
  onClick: () => void;
  className?: string;
}

export default function ExternalLinkSection({
  title,
  onClick,
  className,
}: ExternalLinkSectionProps) {
  return (
    <div className={`m-claim--w-full m-claim--overflow-hidden m-claim--rounded-md ${className}`}>
      <div
        className="m-claim--group m-claim--cursor-pointer m-claim--p-2"
        onClick={onClick}
      >
        <div className="m-claim--inline-flex m-claim--w-full m-claim--items-center m-claim--justify-between m-claim--self-stretch">
          <div className="m-claim--w-full m-claim--font-semimono m-claim--text-xs m-claim--font-normal m-claim--uppercase m-claim--leading-snug m-claim--text-secondary m-claim--transition-colors group-hover:m-claim--text-primary">
            {title}
          </div>
          <div
            data-svg-wrapper
            className="m-claim--relative"
          >
            <img
              height={18}
              width={18}
              src={MArrowRightUpIcon}
              alt="External Link"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
